import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from 'src/app/services/survey.service';
import { UrlService } from 'src/app/services/url.service';
import { DateHelpers } from 'src/app/utils/date.helper';
import { EncryptDecryptService } from 'src/app/utils/encrypt-decrypt.service';
import { HelperService } from 'src/app/utils/helpers';

@Component({
  selector: 'app-end',
  templateUrl: './end.component.html',
  styleUrls: ['./end.component.css']
})
export class EndComponent implements OnInit {

  getvoucher: string = '';
  getshow: string = '';
  voucher: string = '';

  constructor(
    private dateHelper: DateHelpers,
    private service: SurveyService,
    private helper: HelperService,
    private encryptDecryptService: EncryptDecryptService,
    private fb: FormBuilder,
    private url: UrlService,
    private activeRoute: ActivatedRoute,
  ) {
    this.activeRoute.queryParams.subscribe(async (d:any) => {
      this.getvoucher = d.id;
      this.getshow = d.s;
      this.getvouchers()
    });
  }

  ngOnInit(): void {
    // console.log(this.encryptDecryptService.encryptUsingAES256(JSON.stringify('ZZKA44')))
    //  console.log(JSON.parse(this.encryptDecryptService.decryptUsingAES256("3+AakvV5CtRzqAApQt+ROQ==")))
    // this.getvouchers()
    // console.log(this.getvoucher)
  }

  getvouchers(){
    // this.voucher = JSON.parse(this.encryptDecryptService.decryptUsingAES256(this.getvoucher))
    this.service.initgetvouchers(this.getvoucher).subscribe({
      next: (res) => {
        // console.log(res)
        this.voucher = res.data.voucher
      },
      error: (err) => {

      },
      complete: () => {

      }
    });
    // console.log(this.voucher)
  }




  goToPage(link: any) {
    this.url.getWindow().open(link, '_self')
  }

}
